"use client";
import {
  ChartConfig,
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "@/components/ui/chart";
import { Item, ItemTitle } from "@/components/ui/item";
import { UI } from "@/constants";
import { getWeekNumber, numberUsLocale } from "@/lib";
import { WeekGroup } from "@/types";
import { CartesianGrid, Line, LineChart, XAxis, YAxis } from "recharts";

const chartConfig = {
  ordersCount: {
    label: UI.labels.ordersCount,
    color: "var(--chart-4)",
  },
} satisfies ChartConfig;

type OrderTrendsChartProps = {
  orders: WeekGroup[];
};

export const OrderTrendsChart = ({ orders }: OrderTrendsChartProps) => {
  if (!orders?.length) return null;
  const data = orders.map(o => ({
    ...o,
    weekLabel: `${getWeekNumber(o.weekNumber)} ${UI.labels.week}`,
  }));

  return (
    <Item variant="outline">
      <ItemTitle>{UI.titles.orderVolumeTrends}</ItemTitle>
      <ChartContainer config={chartConfig} className="chart-container">
        <LineChart accessibilityLayer data={data}>
          <CartesianGrid vertical={false} />
          <YAxis
            type="number"
            tickMargin={8}
            padding={{ bottom: 16 }}
            tickFormatter={(volume: number) => numberUsLocale(volume)}
          />
          <XAxis
            dataKey="weekLabel"
            tickMargin={8}
            minTickGap={16}
            padding={{ left: 16, right: 16 }}
          />
          <ChartTooltip content={<ChartTooltipContent className="w-52" />} />
          <ChartLegend content={<ChartLegendContent />} />
          <Line
            dataKey="ordersCount"
            type="linear"
            stroke="var(--color-ordersCount)"
            strokeWidth={2}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ChartContainer>
    </Item>
  );
};
